import { types } from "../actions";

const initialState = {
    modalVisible: false,
    modalMessage: '',
};

const idleTimeModalReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SHOW_LOGOUT_IDLE_MODAL:
            console.log("Before modal display", action)
            return {
                ...state,
                modalVisible: true,
                modalMessage: action.payload,
            };
        case types.HIDE_LOGOUT_IDLE_MODAL:
            return initialState;

        default:
            return state;
    }
};

export default idleTimeModalReducer;